import {
  Fragment,
  useContext,
  useReducer,
  useEffect,
  createContext,
} from "react";
import Auth from "../../cookies.config";
import { RouterConfig as NavigationConfig } from "../../../navigation/router-config";
import { PageLoader } from "../../../components/Loaders";

interface ContextState {
  isLoading: boolean;
  isSignout: boolean;
  userToken: object;
}

interface authContextControllerProps {
  signIn: Function;
  signOut: Function;
}

const AuthContext = createContext(
  [] as (ContextState | authContextControllerProps | any)[]
);

const Manipulator = (prevState: any, action: any) => {
  switch (action.type) {
    case "RESTORE_TOKEN":
      return {
        ...prevState,
        userToken: action.userToken,
        isLoading: false,
      };
    case "SIGN_IN":
      return {
        ...prevState,
        isSignout: false,
        userToken: action.userToken,
      };
    case "SIGN_OUT":
      return {
        ...prevState,
        isLoading: false,
        userToken: null,
        isSignout: true,
      };
    default:
      return prevState;
  }
};

function AppNavigator() {
  const [state, dispatch] = useReducer(Manipulator, {
    isLoading: true,
    isSignout: false,
    userToken: null,
  });

  useEffect(() => {
    let userToken: string | null = Auth.getCipher();
    let data;
    if (userToken) data = JSON.parse(userToken);
    else data = null;
    dispatch({ type: "RESTORE_TOKEN", userToken: data });
  }, []);

  return (
    <Fragment>
      {state.isLoading ? (
        <PageLoader />
      ) : (
        <Fragment>
          <NavigationConfig />
        </Fragment>
      )}
    </Fragment>
  );
}

export const useAuthProvider = () => useContext(AuthContext);

export default AppNavigator;
